// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload-myself-info{position:relative;padding-bottom:48px}.upload-myself-info .upload-text-info{position:absolute;bottom:0;font-size:12px;height:48px;line-height:24px;color:#e43420}", ""]);
// Exports
module.exports = exports;
